import { titles } from './constants'

const completed = 'Completed'

// Mirrors IsCompletedSubsidiary in SubsidiaryHotelConfigurationStageHandler.
// Hosted messaging is deliberately excluded there, so it must not block here either.
const stageValueLabels = {
  NotStarted: 'Not started',
  InProgress: 'In progress',
  NotConnected: 'Not connected',
  PartiallyCompleted: 'Partially completed',
  Completed: 'Completed'
}

const readableStageValue = value => stageValueLabels[value] || value || 'Not set'

export const evaluateHotelStatusCheck = hotelConfigData => {
  if (!hotelConfigData) {
    return { isCompleted: false, pendingSteps: [] }
  }

  const pendingSteps = []

  if (hotelConfigData.campaignRegistry !== completed) {
    pendingSteps.push({
      title: titles.campaignRegistry,
      value: readableStageValue(hotelConfigData.campaignRegistry)
    })
  }

  if (hotelConfigData.pmsSync !== completed) {
    pendingSteps.push({
      title: titles.pmsSync,
      value: readableStageValue(hotelConfigData.pmsSync)
    })
  }

  if (!hotelConfigData.tripadvisorSetup) {
    pendingSteps.push({ title: titles.tripAdvisor, value: 'Not set' })
  }

  if (!hotelConfigData.reviewSettingConfiguration) {
    pendingSteps.push({ title: titles.reviewSettings, value: 'Not set' })
  }

  if (!hotelConfigData.beSetup) {
    pendingSteps.push({ title: titles.bookingEngine, value: 'Not set' })
  }

  if (!hotelConfigData.billingAndInvoiceAddress) {
    pendingSteps.push({ title: titles.billingInvoiceAdress, value: 'Not set' })
  }

  if (!hotelConfigData.telcoSetup) {
    pendingSteps.push({ title: titles.phoneNumber, value: 'Not set' })
  }

  if (!hotelConfigData.brandLogoAndColours) {
    pendingSteps.push({ title: titles.logoAndcolors, value: 'Not set' })
  }

  if (!hotelConfigData.initialPaymentMade) {
    pendingSteps.push({ title: titles.initialPayment, value: 'Not made' })
  }

  return { isCompleted: pendingSteps.length === 0, pendingSteps }
}
